var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4H5.5C4.70435 4 3.94129 4.31607 3.37868 4.87868C2.81607 5.44129 2.5 6.20435 2.5 7V17C2.5 17.7956 2.81607 18.5587 3.37868 19.1213C3.94129 19.6839 4.70435 20 5.5 20H19.5C20.2956 20 21.0587 19.6839 21.6213 19.1213C22.1839 18.5587 22.5 17.7956 22.5 17V7C22.5 6.20435 22.1839 5.44129 21.6213 4.87868C21.0587 4.31607 20.2956 4 19.5 4V4ZM19.09 6L13.21 11.88C13.117 11.9737 13.0064 12.0481 12.8846 12.0989C12.7627 12.1497 12.632 12.1758 12.5 12.1758C12.368 12.1758 12.2373 12.1497 12.1154 12.0989C11.9936 12.0481 11.883 11.9737 11.79 11.88L5.91 6H19.09ZM20.5 17C20.5 17.2652 20.3946 17.5196 20.2071 17.7071C20.0196 17.8946 19.7652 18 19.5 18H5.5C5.23478 18 4.98043 17.8946 4.79289 17.7071C4.60536 17.5196 4.5 17.2652 4.5 17V7.41L10.38 13.29C10.9425 13.8518 11.705 14.1674 12.5 14.1674C13.295 14.1674 14.0575 13.8518 14.62 13.29L20.5 7.41V17Z",
    fill: "#1D1E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a960e26f67c67bd841c9da13f9d08d28.svg";
export { ForwardRef as ReactComponent };